import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Inventory_ds_get_shippingcontainers_by_containerTypeId_top1Service {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { containerTypeId: number }): 
  Promise<{ result: { Id?: number } }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.containerTypeId)) {
      $missingRequiredInParams.push('\'containerTypeId\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      containerTypeId: number    }) {
        if(isNil($inParams.containerTypeId)) {
          return true; 
        }
      return false;
    }
}
